import { useState, useCallback } from 'react';
import { API } from 'aws-amplify';
import { getAuthToken } from "../../utils/AuthUtils";

export const useNotes = (surveyYear, companyId, userId) => {
    const [notes, setNotes] = useState([]);
    const [loadingNotes, setLoadingNotes] = useState(false);

    const fetchQuestionnaireNotes = useCallback(async () => {
        setLoadingNotes(true);
        const authToken = await getAuthToken();
        const path = `/survey-questionnaire-submission/notes/${surveyYear}/${companyId}`;

        try {
            const response = await API.get('AnnualCompensations', path, {
                headers: {
                    'Content-Type': 'application/json',
                    'Token': authToken
                }
            });
            setLoadingNotes(false);
            setNotes(response.notes);
            return { success: true };
        } catch (error) {
            console.log(error);
            setLoadingNotes(false);
            return { 
                success: false, 
                error: error?.response?.data?.message || "An error occurred while retrieving questionnaire tracking notes" 
            };
        }
    }, [surveyYear, companyId]);

    const createQuestionnaireNote = async (noteText) => {
        try {
            const authToken = await getAuthToken();
            const path = `/survey-questionnaire-submission/notes/${surveyYear}/${companyId}`;
            const body = { note: noteText };

            await API.post('AnnualCompensations', path, {
                headers: { 'Token': authToken },
                body
            });
            
            await fetchQuestionnaireNotes();
            return { success: true };
        } catch (error) {
            console.log(error);
            return { 
                success: false, 
                error: error?.response?.data?.message || "An error occurred while creating note" 
            };
        }
    };

    const updateQuestionnaireNote = async (uniqueId, noteText) => {
        try {
            const authToken = await getAuthToken();
            const path = `/survey-questionnaire-submission/notes/${surveyYear}/${companyId}/${uniqueId}`;
            const queryStringParameters = { noteUserId: userId };
            const body = { note: noteText };

            await API.put('AnnualCompensations', path, {
                headers: { 'Token': authToken },
                queryStringParameters,
                body
            });

            await fetchQuestionnaireNotes();
            return { success: true };
        } catch (error) {
            console.log(error);
            return { 
                success: false, 
                error: error?.response?.data?.message || "An error occurred while updating note" 
            };
        }
    };

    const deleteQuestionnaireNote = async (uniqueId) => {
        try {
            const authToken = await getAuthToken();
            const path = `/survey-questionnaire-submission/notes/${surveyYear}/${companyId}/${uniqueId}`;

            await API.del('AnnualCompensations', path, {
                headers: { 'Token': authToken }
            });

            await fetchQuestionnaireNotes();
            return { success: true };
        } catch (error) {
            console.log(error);
            return { 
                success: false, 
                error: error?.response?.data?.message || "An error occurred while deleting note" 
            };
        }
    };

    const handleChangeNote = (text, uniqueId) => {
        const tempData = [...notes];
        tempData.find(note => note.id === uniqueId).noteText = text;
        setNotes(tempData);
    };

    return {
        notes,
        loadingNotes,
        fetchQuestionnaireNotes,
        createQuestionnaireNote,
        updateQuestionnaireNote,
        deleteQuestionnaireNote,
        handleChangeNote
    };
}; 